import React, { lazy } from 'react';
import styles from './index.module.scss';

interface IProps {
  path: string;

  [key:string]: any;
}

interface IState {
  component: any;
}

const importView = (path : string) : any => 
  lazy(() => 
    import(`../../pages/${path}`)
      .catch(e => { 
        console.log("Error al cargar pagina", e, `../../pages/${path}`); 
        return import(`../../pages/error/page421`); 
      }
    )
  );

const spin = (
  <div className={`d-flex justify-content-center align-items-center ${styles.fullscreen}`}>
    <div className={styles.panel}>
      <i className="pi pi-spin pi-spinner" style={{fontSize: '3em', color: 'red'}} />
    </div>
  </div>
);

class Index extends React.Component<IProps, IState> {
  state = {
    component: undefined
  }  

  componentDidMount = () => {
    async function loadViews(path: string, t: Index) : Promise<any> {
      const View = await importView(path);
      return (<View {...t.props} />);
    }

    loadViews(this.props.path, this).then(component => this.setState({ component }));
  }

  render() {
    const { component } = this.state;

    return (
      <React.Suspense fallback={spin} >
        {component}
      </React.Suspense>    
    );
  }
}

export default Index;
